import { useCountUp } from "react-countup";
import { useRef, useEffect } from "react";
import React from 'react';
import ReactDOM from 'react-dom/client';

function CounterApp({ start, end, duration, prefix, suffix, decimals }) {
    const countUpRef = useRef(null);
    useCountUp({
        ref: countUpRef,
        start: start || 0,
        end: end,
        duration: duration || 2,
        prefix: prefix || "",
        suffix: suffix || "",
        decimals: decimals || 0,
        enableScrollSpy: true,
    });
    return <span ref={countUpRef} />;
}


// Broadcasting & Podcasting
ReactDOM.createRoot(document.getElementById('broadcastingCounter01')).render(<CounterApp end={73} />);
ReactDOM.createRoot(document.getElementById('broadcastingCounter02')).render(<CounterApp end={1333} />);
ReactDOM.createRoot(document.getElementById('broadcastingCounter03')).render(<CounterApp end={9200} />);
ReactDOM.createRoot(document.getElementById('broadcastingCounter04')).render(<CounterApp end={200} />);
ReactDOM.createRoot(document.getElementById('broadcastingCounter05')).render(<CounterApp end={104} suffix=" million" />);
ReactDOM.createRoot(document.getElementById('broadcastingCounter06')).render(<CounterApp end={80} />);

// Digital Platforms 
ReactDOM.createRoot(document.getElementById('digitalCounter01')).render(<CounterApp end={2200} />);
ReactDOM.createRoot(document.getElementById('digitalCounter02')).render(<CounterApp end={1.3} decimals={1} suffix=" million" />);
ReactDOM.createRoot(document.getElementById('digitalCounter03')).render(<CounterApp end={1.1} decimals={1} suffix=" million"  />);
// ReactDOM.createRoot(document.getElementById('digitalCounter04')).render(<CounterApp end={749}  />);
ReactDOM.createRoot(document.getElementById('digitalCounter05')).render(<CounterApp end={56000}  />);
ReactDOM.createRoot(document.getElementById('digitalCounter06')).render(<CounterApp end={3306}  />);

// Income
ReactDOM.createRoot( document.getElementById('inExCounter01')).render(<CounterApp end={8.7} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter01b')).render(<CounterApp end={8.7} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot( document.getElementById('inExCounter02')).render(<CounterApp end={2.5} duration={3} decimals={1} suffix={"%"}/>);
ReactDOM.createRoot(document.getElementById('inExCounter02b')).render(<CounterApp end={2.5} duration={3} decimals={1} suffix={"%"}/>);
ReactDOM.createRoot( document.getElementById('inExCounter03')).render(<CounterApp end={88.8} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter03b')).render(<CounterApp end={88.8} duration={3} decimals={1} suffix={"%"} />);

// Expenses
ReactDOM.createRoot(document.getElementById('inExCounter04')).render(<CounterApp end={82.3} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter04b')).render(<CounterApp end={82.3} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter05')).render(<CounterApp end={12.3} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter05b')).render(<CounterApp end={12.3} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter06')).render(<CounterApp end={5.4} duration={3} decimals={1} suffix={"%"} />);
ReactDOM.createRoot(document.getElementById('inExCounter06b')).render(<CounterApp end={5.4} duration={3} decimals={1} suffix={"%"} />);
// ReactDOM.createRoot(document.getElementById('counter21')).render(<CounterApp end={88} duration={3} suffix={"%"} />);
// ReactDOM.createRoot(document.getElementById('counter21b')).render(<CounterApp end={88} duration={3} suffix={"%"} />);

